export default new class ArticleViewCounter {
    constructor () {
        this.articleContent = document.querySelector('.wysiwyg ')
        if (this.articleContent != undefined)  {
            const articleParent = this.articleContent.closest('.article')
            if (articleParent != undefined) {
                this.articleID = articleParent.getAttribute('data-article-id')
            }
        }

        this.readPercent = 0

        if (this.articleID != undefined) {
            this.init()
        }
    }

    init () {

        if (this.articleContent.getAttribute('data-user') == 1 ) {
            const articleCoordinates = this.articleContent.getBoundingClientRect()
            const articleCoordinatesTop = articleCoordinates.top + window.scrollY
            const articleHeight = articleCoordinates.height

            if ('onscrollend' in window) {
                document.onscrollend = () => this.calcArticleReading (articleCoordinatesTop, articleHeight)
            } else {
                document.onscroll = () => {
                    clearTimeout(window.scrollEndTimer)
                    window.scrollEndTimer = setTimeout(() => this.calcArticleReading (articleCoordinatesTop, articleHeight), 200)
                }
            }
        }
    }

    calcArticleReading (articleCoordinatesTop, articleHeight) {
        let percent = Math.round((document.documentElement.clientHeight + window.scrollY - articleCoordinatesTop) / (articleHeight) * 100)
        if (percent < 0) {
            percent = 0
        }

        if (percent > 100) {
            percent = 100
        }

        if (percent > this.readPercent) {
            this.readPercent = percent

          //var _paq = window._paq || []
          //_paq.push(['trackEvent', 'Scroll_depth',  this.readPercent]);
          this.sendPercentToServer()
        }
    }

    sendPercentToServer() {

        //console.log('articleID',this.articleID)
        //console.log('процент (send)', this.readPercent)

        $.request('ViewCounter::onSendPercentView', {
            data: {
                article_id: this.articleID,
                percent: this.readPercent
            }
          });
    }

}
